import { Button, Heading } from '@clayui/core';
import ClayLayout from '@clayui/layout';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ClayLink from '@clayui/link';
import OTPInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
    formatTime,
    scopeKeyLeadManagement,
    scopeKeyPitchForm
} from '../../utils/Config';
import SubmitButton from '../../generic-components/button/FormButton';
import { useAppSelector } from '../../store/hooks';
import { otpService } from '../../services/otpService';
import {
    primaryButtonStyle,
    scrollToSection,
    secondaryButtonStyle
} from '../../utils/commonUtil';
import '../AttractionComponents/AttractionBasicDetail/AttractionBasicDetail.css';
import { expansionInquiryService } from '../../services/expansionInquiryService';
import {
    setFormId,
    setIsFormFilled,
    setPreviousFromCountryData
} from '../../slices/businessExpansionSlice';
import { RootState } from '../../store';
const OtpVerification: React.FC<{
    setStep: React.Dispatch<React.SetStateAction<number>>;
    btnUi: 'blue' | 'green';
    onLoadingChange?: (loading: boolean) => void;
}> = ({ setStep, btnUi, onLoadingChange }) => {
    const {
        formState: { errors },
        handleSubmit
    } = useForm();
    const businessEmail = useAppSelector((state) => state.common.businessEmail);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [otp, setOtp] = useState('');
    const [isDisable, setIsDisable] = useState<boolean>(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [timer, setTimer] = useState(180);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const formValues = useAppSelector((state) => state.businessExpansion);
    const dispatch = useDispatch();
    const basicDetail = useSelector((state: RootState) => state.common);
    const route = basicDetail.liferayRoute;
    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;
        if (isResendDisabled) {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    if (prevTimer <= 1) {
                        if (interval) clearInterval(interval);
                        setIsResendDisabled(false);
                        return 0;
                    }
                    return prevTimer - 1;
                });
            }, 1000);
        } else if (!isResendDisabled && timer !== 0) {
            if (interval) clearInterval(interval);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isResendDisabled, timer]);

    const onSubmit = async (e: any) => {
        setIsDisable(true);
        setResponseMessage('');
        setIsLoading(true);
        onLoadingChange?.(true);
        const response = await otpService.verigyOTP(
            businessEmail ?? '',
            Number(otp),
            route === '/pitch-form' ? scopeKeyPitchForm : scopeKeyLeadManagement
        );

        if (response.statusCode === 406) {
            setIsDisable(false);
        }
        if (response.statusCode === 404) {
            setResponseMessage(response.statusMessage);
        } else if (response.statusCode === 410) {
            setResponseMessage(response.statusMessage);
            setIsResendDisabled(false);
            setTimer(0);
            setIsDisable(true);
        } else if (response.statusCode === 200) {
            toast.success('OTP Verified', {
                theme: 'light',
                autoClose: 2000
            });

            if (formValues?.haveYouFill == 'no') {
                try {
                    const response =
                        (await expansionInquiryService.getAlreadyFormFillData(
                            businessEmail ?? '',
                            Number(formValues?.dcMembershipNumber)
                        )) as {
                            success?: boolean;
                            message?: string;
                            data?: {
                                totalCount?: number;
                                items: any[];
                            };
                        };

                    if (response.success && response.data?.items?.length == 1) {
                        const data = response.data.items[0];

                        const previousCountryData =
                            data?.expansionInquiryToExpansionInquiryLead?.map(
                                (item: any) => {
                                    const purposes =
                                        item?.businessPurpose || [];

                                    const otherPurpose = purposes.find(
                                        (p: any) => p.name === 'Others'
                                    );
                                    const normalPurposes = purposes
                                        .filter((p: any) => p.name !== 'Others')
                                        .map((p: any) => p.name);

                                    let businessPurpose =
                                        normalPurposes.join(', ');

                                    if (otherPurpose) {
                                        const otherValue =
                                            item?.otherBusinessPurpose
                                                ? `Others: ${item.otherBusinessPurpose}`
                                                : 'Others';

                                        businessPurpose = businessPurpose
                                            ? `${businessPurpose}, ${otherValue}`
                                            : otherValue;
                                    }

                                    return {
                                        targetMarket: item?.targetMarkets?.name,
                                        previousExperience:
                                            item?.previousExperience === true
                                                ? 'Yes'
                                                : 'No',
                                        purposeOfExpansion: businessPurpose,
                                        marketPriority:
                                            item?.isPrimaryTargetMarket
                                                ? 'Primary'
                                                : 'Secondary'
                                    };
                                }
                            );
                        toast.success(
                            `You have previously filled out the form using ${businessEmail}`,
                            {
                                theme: 'light',
                                autoClose: 2000
                            }
                        );
                        dispatch(setFormId(Number(data?.id)));
                        dispatch(setIsFormFilled(true));
                        dispatch(
                            setPreviousFromCountryData(previousCountryData)
                        );
                        setStep(2);
                        scrollToSection();
                    }

                    if (response.success && response.data?.totalCount == 0) {
                        // toast.error(
                        //     `You have not previously filled out the form using ${businessEmail}`,
                        //     {
                        //         theme: 'light',
                        //         autoClose: 2000
                        //     }
                        // );
                        setStep(2);
                        scrollToSection();
                    }
                } catch (err: any) {
                    toast.error(err?.message || 'Failed to submit inquiry', {
                        theme: 'light',
                        autoClose: 4000
                    });
                }
            } else {
                setStep(2);
                scrollToSection();
            }
        } else {
            setResponseMessage(response.statusMessage);
        }

        setIsLoading(false);
        onLoadingChange?.(false);
    };

    const handleResendOTP = async (e: any) => {
        e.preventDefault();
        setResponseMessage('');
        setTimer(180);
        setIsResendDisabled(true);
        setIsDisable(false);

        const response = await otpService.gerateOTP(
            businessEmail ?? '',
            route === '/pitch-form' ? scopeKeyPitchForm : scopeKeyLeadManagement
        );

        if (response.statusCode === 200) {
            toast.success(
                'OTP has been sent to your registered email address',
                {
                    theme: 'light',
                    autoClose: 2000
                }
            );
            setOtp('');
        } else {
            toast.error('Failed to resend OTP. Please try again.', {
                theme: 'light',
                autoClose: 2000
            });
        }
    };

    const handleOTP = (e: string) => {
        setResponseMessage('');
        setOtp(e);
    };

    // const isLoading = UserVerification.isLoading;

    return (
        <ClayLayout.ContentSection className="verification_container">
            <ClayLayout.Row justify="center" className="verification_header">
                <ClayLayout.Col size={12}>
                    <Heading level={4} weight="bold">
                        OTP Verification
                    </Heading>
                </ClayLayout.Col>
                <ClayLayout.Col
                    size={12}
                    className="verification_text text-primary"
                >
                    One-time password has been sent to your register
                </ClayLayout.Col>
                <ClayLayout.Col
                    size={12}
                    className="verification_text text-primary"
                >
                    email address ({businessEmail}). It is valid for 5 Minutes.
                </ClayLayout.Col>
            </ClayLayout.Row>
            <form onSubmit={handleSubmit(onSubmit)} className="w-100">
                <ClayLayout.Row
                    justify="center"
                    className="basic_detail_form mb-4"
                >
                    <ClayLayout.Col size={12} className="detail-inputs">
                        <OTPInput
                            value={otp}
                            onChange={(e) => handleOTP(e)}
                            numInputs={6}
                            renderInput={(props) => (
                                <input
                                    {...props}
                                    type="number"
                                    className="verification_input custom_input mr-4 no-spinner"
                                    required
                                />
                            )}
                        />
                        {responseMessage && (
                            <p className="response_message">
                                {!isLoading && responseMessage}
                            </p>
                        )}
                    </ClayLayout.Col>
                </ClayLayout.Row>

                <ClayLayout.ContentSection className="resend_otp">
                    <div>
                        <span>Didn’t receive OTP code? Please wait </span>{' '}
                        <ClayLink displayType="primary">
                            {formatTime(timer)}
                        </ClayLink>
                    </div>
                    <Button
                        className="resend-btn"
                        disabled={isResendDisabled}
                        onClick={handleResendOTP}
                    >
                        <ClayLink displayType="primary">Resend OTP</ClayLink>
                    </Button>
                </ClayLayout.ContentSection>
                {btnUi === 'blue' ? (
                    <div className="button_container">
                        {/* <SubmitButton disable={isDisable} label="Verify Email" /> */}
                        <Button
                            type="submit"
                            className="bottom-cut"
                            disabled={isDisable}
                            style={primaryButtonStyle}
                        >
                            <span className="bottom-cut-span"></span>
                            Verify Email
                        </Button>
                    </div>
                ) : (
                    <div className="submit-button-container">
                        <Button
                            type="submit"
                            className="bottom-cut"
                            style={secondaryButtonStyle}
                        >
                            <span className="bottom-cut-span"></span>
                            Verify Email
                        </Button>
                    </div>
                )}
            </form>
        </ClayLayout.ContentSection>
    );
};

export default OtpVerification;
